import React, { Component } from 'react';
import styled from 'styled-components';
import * as MDICONS from '@material-ui/icons';
import { connect } from 'react-redux'
import logo from '../../assets/logo/roundedLogo.png';
import { createCompany, createCompanyViaApi } from '../../store/actions/companyActions';
const EditButton = styled.div`
    .btn {
        color: #fafafa;
        border-color: #040926;
        background-color: #040926;
        margin: 2px;

        &:hover {
            background-color: #040850;
        }

        &:active {
            background-color: #040850;
        }
    }
`;


class CreateCompanyModal extends Component {

    constructor(props) {
        super()

        this.state = {
            usePersonalDetails: true,
            email: "",
            name: "",
            phone: "",
            address: "",
            selectedDp: null,
            selectedDpPreview: "",
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { userId, userData} = this.props;

        const companyData = {
            companyName: this.state.name ?? "",
            email: this.state.email ?? "",
            phone: this.state.phone ?? "",
            address: this.state.address ?? "",
            visibility:false,
        };
        const createdVia = "webcom";
        this.props.createCompanyViaApi(userData,companyData,createdVia,this.state.selectedDp);
        // this.props.createCompany(userData, companyData, this.state.selectedDp);
    }

    handleFileSelect = (e) => {
        let reader = new FileReader();
        let selectedDp = e.target.files[0];

        if (selectedDp && this.checkMimeType(e)) {
            reader.onloadend = () => {
                this.setState({
                    selectedDp,
                    selectedDpPreview: reader.result,
                });
            }
        }
        reader.readAsDataURL(selectedDp)
    }

    checkMimeType = (e) => {
        let files = e.target.files;
        let err = '';
        const types = ['image/jpeg', 'image/png', 'image/JPEG', 'image/PNG']
        for (var x = 0; x < files.length; x++) {
            if (!types.includes(files[x].type)) {
                err = 'File is not in a supported format\n';
                alert(err);
            }
        };
        if (err !== '') {
            e.target.value = null // discard selected file
            console.log(err)
            return false;
        }
        return true;
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    componentDidMount() {
        const { userData } = this.props;
        const { name, phone, address, email } = userData;

        this.setState({
            email,
            name,
            phone,
            address
        });
    }

    render() {
        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: seeing the state of form (do styling adjustments but be cautious with state)
        ///
        const { isCompanyCreating, isFilesAdded } = this.props.company;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const relevantSubmitComponent = !isCompanyCreating ? <button className="btn btn-dark btn-sm" type="submit" disabled={isCompanyCreating}>Confirm and create</button> : <button className="btn btn-dark btn-sm" type="button" disabled>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            &nbsp; Creating new company
        </button>

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: return the form
        ///
        const formLabelStyle = {
            fontSize: "12px",
            fontWeight: "bold",
        };

        const zStyle = {
            left: "400px",
            right: "0px",
            top: "160px",
            position: "absolute",
            zIndex: "auto",
        };


        const { userId, modalWidth, modalTitleStyle } = this.props;
        const { phone, address, name, email } = this.state;

        const { selectedDpPreview, selectedDp } = this.state;
        var selectedDpComponent = <img src={selectedDpPreview ? selectedDpPreview : logo} alt="" className="avatar" id="profilePic" style={{ width: "150px", height: "150px" }} />;

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModal" style={{ height: '590px' }}>
                    <div className="px-3">
                        <p style={modalTitleStyle}>Create new company</p>
                        {/* Moved out of form to prevent onSubmit handle */}
                        {/* SELECT DP */}
                        <div className="form-group text-center">
                            <label style={formLabelStyle}>Display picture</label>
                            <div className="align-items-center">
                                <div>
                                    {selectedDpComponent}
                                    <button className="btn btn-light btn-sm" style={zStyle} >
                                        <label htmlFor="files" style={{ fontWeight: "bold" }}>
                                            <MDICONS.EditRounded />
                                        </label>
                                    </button>
                                </div>
                                <input type="file" className="file" id="files" style={{ fontWeight: "bold", fontSize: "8px", display: "none" }} onChange={this.handleFileSelect} />

                            </div>
                        </div>

                        {/* MAIN FORM */}
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group text-left">
                                <div className="form-group text-left">
                                    <label htmlFor="inputText" style={formLabelStyle}>Company name *</label>
                                    <input type="text" className="form-control" id="name" onChange={this.handleChange} required value={name} />
                                </div>
                                <div className="form-group text-left">
                                    <label htmlFor="inputText" style={formLabelStyle}>Company email *</label>
                                    <input type="email" className="form-control" id="email" onChange={this.handleChange} required value={email} />
                                </div>
                                <label htmlFor="inputText" style={formLabelStyle}>Company phone *</label>
                                <input type="tel" className="form-control" id="phone" placeholder="Hint: +441234567899" pattern="[+]{1}[0-9]{2,}" onChange={this.handleChange} required value={phone} />
                            </div>
                            <div className="form-group text-left">
                                <label htmlFor="inputText" style={formLabelStyle}>Work address *</label>
                                <input type="text" className="form-control" id="address" onChange={this.handleChange} required value={address} />
                            </div>

                            {relevantSubmitComponent}
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    // console.log(state.firebase.data.Company)
    return {
        auth: state.auth,
        themeColors: state.theme,
        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,
        project: state.project,
        userId: state.firebase.auth.uid,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        company: state.company,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createCompany: (userData, companyData, selectedDp) => dispatch(createCompany(userData, companyData, selectedDp)),
        createCompanyViaApi: (userModelJson, companyModelJson, createdVia, selectedDp) => dispatch(createCompanyViaApi(userModelJson, companyModelJson, createdVia, selectedDp))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCompanyModal);
